"use client";

import { createContext, useCallback, useContext, type ReactNode } from "react";
import {
  captureWalesBetaEvent,
  resetWalesBetaAnalytics,
  type WalesBetaAnalyticsEvents,
} from "./walesBetaAnalytics";

const WalesBetaAnalyticsContext = createContext(false);

export function WalesBetaAnalyticsContextProvider({
  children,
  enabled,
}: {
  children: ReactNode;
  enabled: boolean;
}) {
  return (
    <WalesBetaAnalyticsContext.Provider value={enabled}>
      {children}
    </WalesBetaAnalyticsContext.Provider>
  );
}

export function useWalesBetaAnalytics() {
  const enabled = useContext(WalesBetaAnalyticsContext);

  const capture = useCallback(
    <EventName extends keyof WalesBetaAnalyticsEvents>(
      event: EventName,
      properties: WalesBetaAnalyticsEvents[EventName],
    ) => {
      if (enabled) {
        captureWalesBetaEvent(event, properties);
      }
    },
    [enabled],
  );

  const reset = useCallback(() => {
    resetWalesBetaAnalytics();
  }, []);

  return { capture, enabled, reset };
}
